export interface MapWorkout {
    id: string;
    type: string;
    positions: Array<[number, number]>; // [longitude, latitude]
    color: string;
}

export interface MapCheckIn {
    id: string;
    type: string;
    location: [number, number]; // [longitude, latitude]
    name: string;
    color: string;
}

export interface BoundingBox {
    southWest: [number, number]; // [longitude, latitude]
    northEast: [number, number]; // [longitude, latitude]
}

export interface ViewState {
    longitude: number;
    latitude: number;
    zoom: number;
}

export const DEFAULT_VIEW_STATE: ViewState = {
    longitude: 19.945, // Krakow, Poland
    latitude: 50.0647,
    zoom: 12
};
